import { createApp } from 'vue';
import ReturnsApi from './returns-api.mjs';
import ReturnsTranslation from './returns-translations.mjs';
import ReturnsWizard from './returns-wizard.mjs';

import( "./returns.css" );

const app = createApp( {
	setup() {
		return {};
	},
	mounted() {
	},
	components: {
		ReturnsWizard
	},
	template: '<ReturnsWizard />'
} );

app.use( ReturnsApi );
app.use( ReturnsTranslation );
app.mount( '#returns-app' );
